import React from "react";
import { Table } from "antd";
import { useAppModel } from "../appModel";
import { ColumnsType } from "antd/es/table";
import { IMdAppDetail } from "../AppTypes";
import moment from "moment";
import { getBaseImgLookUrl } from "@src/utils/constants";
import { momentFormats } from "@src/utils/utils";

const columns: ColumnsType<IMdAppDetail> = [
    {
        align: 'center',
        title: '序号',
        width: 60,
        render: (v, r, i) => i + 1
    },
    {
        align: "center",
        title: '应用编码',
        width: 200,
        dataIndex: 'code',
    },
    {
        align: "center",
        title: '应用图标',
        width: 200,
        dataIndex: 'iconUrl',
        render: (v: string, r: IMdAppDetail) => <img width="60" src={getBaseImgLookUrl(v)} alt={r.name} />
    },
    {
        align: "center",
        title: '应用名称',
        width: 320,
        dataIndex: 'name',
    },
    {
        align: "center",
        title: '应用类型',
        width: 200,
        dataIndex: 'appTypeName',
    },
    {
        align: "center",
        title: '应用描述',
        width: 200,
        dataIndex: 'note',
    },
    {
        align: "center",
        title: '应用地址',
        width: 320,
        dataIndex: 'appUrl',
    },
    // {
    //     align: "center",
    //     title: '创建人',
    //     width: 200,
    //     dataIndex: 'createUser',
    // },
    {
        align: "center",
        title: '创建时间',
        width: 320,
        dataIndex: 'createTime',
        render: (value) => momentFormats(value)
    },
    {
        align: "center",
        title: '状态',
        dataIndex: 'enable',
        width: 120,
        render: (v) => v === 0 ? "禁用" : "启用"
    },
];

export function DataTable() {
    const {
        dataSource,
        pgCfg,
        loadData,
    } = useAppModel();


    return (
        <Table
            style={{ cursor: "pointer" }}
            // rowSelection={{
            //     type: "radio",
            //     onChange: (selectedRowKeys: React.Key[], selectedRows: IMdAppDetail[]) => {
            //         setSelectedRowKeys(selectedRowKeys);
            //     },
            //     selectedRowKeys
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
        // onRow={record => {
        //     return {
        //         onClick: event => {
        //             if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
        //                 setSelectedRowKeys([]);
        //             } else {
        //                 setSelectedRowKeys([record.key]);
        //             }
        //         },
        //     };
        // }}
        />
    )
}


